import React from "react";
import { useStripe, CardElement, useElements } from "@stripe/react-stripe-js";
import { useSnackbar } from "notistack";
import "react-credit-cards-2/dist/es/styles-compiled.css"; // ✅ Correct for react-credit-cards-2

const CardInformation = ({
  handleCardAction,
  isLoading,
  setIsLoading,
  headingTitle,
  classes,
  buttonText,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (elements == null) {
      return;
    }

    setIsLoading(true);

    const cardElement = elements.getElement(CardElement);

    stripe.createToken(cardElement).then(function (result) {
      // Handle result.error or result.token

      if (result.error) {
        setIsLoading(false);
        enqueueSnackbar(result.error.message, { variant: "error" });
        return;
      }
      handleCardAction(result.token.id, cardElement);
    });
  };

  return (
    <>
      <h4 className={`${classes ? classes : ""}`}>{`${
        headingTitle ? headingTitle : "Enter Card Details"
      } `}</h4>
      <div className="row mb-3">
        <div className="col-12 text-end">
          <form onSubmit={handleSubmit}>
            <div className="card p-3">
              <CardElement
                options={{
                  hidePostalCode: true,
                  style: {
                    base: {
                      iconColor: "var(--portal-primary-color)",
                      color: "var(--portal-primary-color)",
                      "::placeholder": {
                        color: "#d9d0d0",
                      },
                      fontSize: "18px",
                    },
                  },
                }}
              />
            </div>
            {isLoading ? (
              <button
                className="theme-button-contained button-lg w-100 mt-4"
                disabled={true}
              >
                Processing...
              </button>
            ) : (
              <button
                className="theme-button-contained button-lg w-100 mt-4"
                type="submit"
                disabled={!stripe || !elements}
              >
                {buttonText ? buttonText : "Pay Now"}
              </button>
            )}
          </form>
        </div>
      </div>
    </>
  );
};
export default CardInformation;
